import React, { useContext, memo } from "react";
import { useEffect } from "react";
import { StatsContext } from "./StatsContext";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import PopupD from "../PopupD";
import PopupE from "../PopupE";
const Stats = () => {
  const StatsModel = useContext(StatsContext);
  const {
    statsData,
    zonalPositionData,
    zoneAnlysticData,
    totalMemberCount,
    totalPendingMemberCount,
    sendSMSReminder,
    totalCount,
    handleShowModal,
    showSMSRemiderPopup,
    modalMessage,
    statusModal,
    setStatusModal,
    handleCloseModal,
    handleChangeMessage,
    messageData,
    reminderMsgValidation,
    setReminderMsgValidation,
    modalSuccess,
    modalWarning,
  } = StatsModel;

  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "zone_name",
      text: "Zone",
      sort: false,
      headerClasses: "tableHeader",
    },
    {
      dataField: "total",
      text: "Total Voters",
      sort: true,
      headerClasses: "tableHeader",
    },
    {
      dataField: "voted",
      text: "Votes Cast",
      sort: true,
      headerClasses: "tableHeader",
    },
    {
      dataField: "pending",
      text: "Votes Pending",
      sort: false,
      headerClasses: "tableHeader",
    },

    {
      dataField: "votedPercentage",
      text: "Participation (%)",
      sort: true,
      headerClasses: "tableHeader",
    },
  ];
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    lastPageText: "Last",
    firstPageText: "First",
    nextPageText: "Next",
    prePageText: "Previous",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {},
    onSizePerPageChange: function (page, sizePerPage) {},
  });
  return (
    <div>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin">
              <div className="d-flex justify-content-between flex-wrap">
                <div className="d-flex align-items-center dashboard-header flex-wrap mb-3 mb-sm-0">
                  <h4 className="mr-4 mb-0 font-weight-bold">Statistics</h4>
                </div>
              </div>
              <div className="ml-auto">
                <button
                  className="btn btn-danger ml-3 btnRight"
                  type="button"
                  onClick={() => {
                    handleShowModal();
                  }}
                >
                  SMS Reminder
                </button>
              </div>
            </div>
          </div>

          <div>
            <p className="card-title flex-grow">
              <div className="mb-3">
                <h4 className="mr-4 font-weight-300">
                  Total Voters:
                  {totalMemberCount}
                </h4>
              </div>
              <div>
                <h4 className="mr-4 font-weight-300">
                  Total Votes Cast: {totalCount}
                </h4>
              </div>
              <div>
                <h4 className="mr-4 font-weight-300">
                  Total Votes Pending: {totalPendingMemberCount}
                </h4>
              </div>
            </p>
          </div>
          <div style={{ width: "100%" }}>
            <ToolkitProvider
              keyField="id"
              data={zoneAnlysticData}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={pagination}
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>
      <PopupE
        show={showSMSRemiderPopup}
        handleClose={handleCloseModal}
        title="SMS Reminder"
        placeholder="Enter message"
        onChangeMessage={handleChangeMessage}
        message={messageData}
        label="Message"
        saveData={sendSMSReminder}
        messageValidation={reminderMsgValidation}
        setMessageValidation={setReminderMsgValidation}
      />
      <PopupD
        showPopup={statusModal}
        setShowPopup={setStatusModal}
        isSuccess={modalSuccess}
        message={modalMessage}
        isWarning={modalWarning}
      />
    </div>
    // <div>
    //         {statsData || zoneAnlysticData ? (
    //           <p className="card-title flex-grow">
    //             <div className="mb-3">
    //               <h4 className="mr-4 font-weight-300">
    //                 Total Voters:

    //                 {totalMemberCount}
    //               </h4>
    //             </div>
    //             <div>
    //               <h4 className="mr-4 font-weight-300">
    //                 Total Votes Cast: {totalCount}

    //               </h4>
    //             </div>
    //              <div>
    //               <h4 className="mr-4 font-weight-300">
    //                 Total Votes Pending: {totalPendingMemberCount}

    //               </h4>
    //             </div>
    //             {/* <strong>
    //                                   <h4 className="mr-4 mb-2 font-weight-bold"> Total Members who have voted until now: {statsData}</h4>
    //                               </strong>
    //                                <strong>
    //                                   <h4 className="mr-4 mb-2 font-weight-bold"> Total vote casted : 100/1000</h4>
    //                               </strong> */}
    //             {zonalPositionData &&
    //               zonalPositionData?.map((item, index) => {
    //                 const nameFirst =
    //                   item.association_position.name.split(",");
    //                 if (nameFirst[0] === "Zonal Secretary") {
    //                   return (
    //                     <div
    //                       style={{
    //                         display: "flex",
    //                         paddingTop: "8px",
    //                         paddingLeft: "5px",
    //                       }}
    //                     >
    //                       <div>
    //                         <strong>Zonal Secretary, {nameFirst[1]} -</strong>
    //                       </div>
    //                       <div style={{ paddingLeft: "4px" }}>
    //                         {item.totalPoll}
    //                       </div>
    //                     </div>
    //                   );
    //                 }
    //               })}
    //           </p>
    //         ) : (
    //           <strong>
    //             <h4 className="mr-4 mb-2 font-weight-bold">
    //               No data available
    //             </h4>
    //           </strong>
    //         )}

    //       </div>
  );
};

export default memo(Stats);
